import { RendererParams } from '@xt/questionnaire-cdk';

export function isRendererParams(value?: unknown): value is RendererParams {
  return (
    !!value &&
    typeof value === 'object' &&
    'questionnaireId' in value &&
    typeof value.questionnaireId === 'string'
  );
}

export interface CurRendererParams extends RendererParams {
  serviceRequestId?: string;
}

export function isRendererParamsWithServiceRequestId(
  value: unknown,
): value is CurRendererParams {
  return (
    isRendererParams(value) &&
    'serviceRequestId' in value &&
    typeof value['serviceRequestId'] === 'string'
  );
}
